import React from 'react';
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import FormSectionHeader from './FormSectionHeader';

interface BusinessDetailsFieldsProps {
  formData: {
    business_name: string;
    description: string;
    target_segment: string;
  };
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const BusinessDetailsFields: React.FC<BusinessDetailsFieldsProps> = ({ 
  formData, 
  setFormData 
}) => {
  return (
    <div className="space-y-4">
      <FormSectionHeader 
        title="Business Details" 
        description="Basic information about your business" 
        required={true}
      />
      
      <div>
        <Label htmlFor="business_name">Business Name</Label>
        <Input
          id="business_name"
          value={formData.business_name}
          onChange={(e) => setFormData(prev => ({ ...prev, business_name: e.target.value }))}
          required
          placeholder="Enter your business name"
        />
      </div>
      
      <div>
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          value={formData.description}
          onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
          required
          placeholder="Describe your business"
          rows={4}
        />
      </div>

      <div>
        <Label htmlFor="target_segment">Target Market</Label>
        <Textarea
          id="target_segment"
          value={formData.target_segment || ''}
          onChange={(e) => setFormData(prev => ({ ...prev, target_segment: e.target.value }))}
          placeholder="Describe your target market"
          rows={4}
        />
      </div>
    </div>
  );
};

export default BusinessDetailsFields;
